import script from "./Error503View.vue?vue&type=script&setup=true&lang=js"
export * from "./Error503View.vue?vue&type=script&setup=true&lang=js"

import "./Error503View.vue?vue&type=style&index=0&id=556eca3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-556eca3d"]])

export default __exports__